import { Routes, Route, Navigate } from 'react-router-dom'
import { UserLayout } from '../components/layouts'
import UserDashboard from '../pages/Dashboard/User'
import UserProfile from '../pages/Profile/UserProfile'
import MatchingCandidate from '../pages/Dashboard/Candidate/MatchingCandidate'
import Candidate from '../pages/Dashboard/Candidate/Candidate'
import CandidateDetail from '../pages/Dashboard/Candidate/CandidateDetail'
import Meeting from '../pages/Dashboard/Meeting'
import FavoriteCandidats from '../pages/Dashboard/Candidate/FavoriteCandidats'
import Besoins from '../pages/Dashboard/Company/Besoins'
import EditBesoinEntreprisePage from '../pages/Admin/EditBesoinEntreprisePage'
import { useSelector } from 'react-redux'
import { ROLE_ADMIN, ROLE_CANDIDAT, ROLE_ENTREPRISE, ROLE_MINI_ADMIN, ROLE_SUPER_ADMIN } from '../data'

const UserRouter = () => {
  const currentUser = useSelector((state) => state.userAuth.user)

  const isCandidat = () => {
    return currentUser?.data?.role === ROLE_CANDIDAT
  }
  const isEntreprise = () => {
    return currentUser?.data?.role === ROLE_ENTREPRISE
  }
  const isAdmin = () => {
    return currentUser?.data?.role === ROLE_SUPER_ADMIN || currentUser?.data?.role === ROLE_MINI_ADMIN || currentUser?.data?.role === ROLE_ADMIN
  }

  return (
    <Routes>
      <Route
        element={
          isEntreprise() || isCandidat() ? (
            <UserLayout />
          ) : (
            <Navigate replace to={'/'} />
          )
        }
      >
        <Route index element={<UserDashboard />} />
        <Route path={'mon-profil'} element={<UserProfile />} />
        <Route
          path={'/candidat/matching/:besoinId'}
          element={
            isEntreprise() ? (
              <MatchingCandidate />
            ) : (
              <Navigate replace to={'/'} />
            )
          }
        />
        <Route
          path={'/candidat/favoris'}
          element={
            false && isEntreprise() ? (
              <FavoriteCandidats />
            ) : (
              <Navigate replace to={'/'} />
            )
          }
        />
        <Route path={'/event/:eventId'} element={<UserDashboard />} />
        <Route
          path={'/candidats'}
          element={
            false && isEntreprise() ? (
              <Candidate />
            ) : (
              <Navigate replace to={'/'} />
            )
          }
        />
        <Route
          path={'/candidats/:id'}
          element={
            false && isEntreprise() ? (
              <CandidateDetail />
            ) : (
              <Navigate replace to={'/'} />
            )
          }
        />
        <Route
          path={'/annonces'}
          element={isCandidat() ? <Besoins /> : <Navigate replace to={'/'} />}
        />
        <Route
          path={'/annonces/:mode'}
          element={
            isEntreprise() || isAdmin() ? (
              <EditBesoinEntreprisePage />
            ) : (
              <Navigate replace to={'/'} />
            )
          }
        />
        <Route
          path={'/annonces/:mode/:besoinId'}
          element={
            isEntreprise() || isAdmin() ? (
              <EditBesoinEntreprisePage />
            ) : (
              <Navigate replace to={'/'} />
            )
          }
        />
        <Route path={'/meeting/:meetingId'} element={<Meeting />} />
      </Route>
    </Routes>
  )
}

export default UserRouter
